import { c as _c } from "react/compiler-runtime";
import EditActionWrapper, { ACCESSIBLE_LABEL_REQUIRED_CLASSNAME, ACCESSIBLE_LABEL_ROW_CLASSNAME } from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { ActionSmsEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import { SmsTemplateFlow } from 'modules/automation-rules/sms/sms-template-flow';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import { SmsTemplateId } from 'modules/sms/types';
import React from 'react';
import { FormSelect } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ActionSmsItemProps extends EditActionItemInterface<ActionSmsEditInterface> {}
const ActionSmsItem = t0 => {
  const $ = _c(15);
  const {
    actions,
    setRules,
    errors,
    idx,
    action,
    onDelete
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== action.id || $[4] !== action.smsTemplate || $[5] !== actions || $[6] !== errors.automationActions || $[7] !== idx || $[8] !== setRules || $[9] !== t) {
    t2 = t3 => {
      const {
        data,
        onOpen
      } = t3;
      return <div className="flex flex-col gap-2"><div className={ACCESSIBLE_LABEL_ROW_CLASSNAME}><span className={ACCESSIBLE_LABEL_REQUIRED_CLASSNAME} data-required={true}>{t("dashboard.automation_rule.sms")}</span><span className="flex h-5 items-center gap-1.5 [&_svg]:size-4 [&_svg]:shrink-0"><SmsTemplateFlow onSuccess={async data_0 => setRules(prev => ({
              ...prev,
              actions: actions.map((el, i) => {
                if (idx === i) {
                  return {
                    ...el,
                    smsTemplate: data_0
                  };
                } else {
                  return el;
                }
              })
            }))} />{action.smsTemplate.id && <SmsTemplateFlow templateId={action.smsTemplate.id} noRedirectOnNotFoundError={true} onSuccess={async data_1 => setRules(prev_0 => ({
              ...prev_0,
              actions: actions.map((el_0, i_0) => {
                if (idx === i_0) {
                  return {
                    ...el_0,
                    smsTemplate: data_1
                  };
                } else {
                  return el_0;
                }
              })
            }))} />}</span></div><FormSelect ariaLabel={t("dashboard.automation_rule.sms")} onOpen={onOpen} placeholder={t("dashboard.automation_rule.choose_sms_template")} required={true} value={action.smsTemplate.id} staticData={getDataFromObj({
          id: action.smsTemplate.id,
          name: action.smsTemplate.name
        })} data={data.smsTemplateData} onChange={data_2 => setRules(prev_1 => ({
          ...prev_1,
          actions: actions.map((el_1, i_1) => {
            if (idx === i_1) {
              return {
                ...el_1,
                smsTemplate: {
                  ...action.smsTemplate,
                  id: data_2 as unknown as SmsTemplateId
                }
              };
            } else {
              return el_1;
            }
          })
        }))} error={errors.automationActions[action.id]?.smsTemplateId?.join("") || ""} /></div>;
    };
    $[3] = action.id;
    $[4] = action.smsTemplate;
    $[5] = actions;
    $[6] = errors.automationActions;
    $[7] = idx;
    $[8] = setRules;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== action.type || $[12] !== t1 || $[13] !== t2) {
    t3 = <EditActionWrapper slug={action.type} onDelete={t1}>{t2}</EditActionWrapper>;
    $[11] = action.type;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default ActionSmsItem;